// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HighlightTwoToneSvg from "@ant-design/icons-svg/es/asn/HighlightTwoTone";
import AntdIcon from '../components/AntdIcon';

var HighlightTwoTone = function HighlightTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HighlightTwoToneSvg
  }));
};

HighlightTwoTone.displayName = 'HighlightTwoTone';
export default React.forwardRef(HighlightTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/HighlightTwoTone.js
// module id = 1311
// module chunks = 0